import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SidenavService } from '../core/sidenav.service';

@Component({
  selector: 'app-devices-reports',
  templateUrl: './devices-reports.component.html',
  styleUrls: ['./devices-reports.component.scss'],
})
export class DevicesReportsComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav;

  width: number;
  iconLink: string;
  subscriptions: Subscription[] = [];
  isLoading: boolean;
  selectedTab: number;
  constructor(public sidenavService: SidenavService, private router: Router) {}

  ngOnInit() {
    this.iconLink = 'assets/interface/reports/reports.png';
    this.sidenavService.setSidenav(this.sidenav);
  }

  onTabOpen(event) {
    setTimeout(() => {
      const element: HTMLElement =
        event.originalEvent.target.parentElement.parentElement.parentElement;
      const scrollElement = document.getElementById('contentScroll');
      if (scrollElement.scrollTop > element.offsetTop)
        scrollElement.scroll({
          behavior: 'smooth',
          top: element.offsetTop,
        });
      else if (
        scrollElement.scrollTop + scrollElement.clientHeight <
        element.offsetTop + element.offsetHeight
      )
        scrollElement.scroll({
          behavior: 'smooth',
          top: this.canBeFullyVisible(element, scrollElement)
            ? this.offsetToAttachBottom(element, scrollElement) > 0
              ? this.offsetToAttachBottom(element, scrollElement)
              : element.offsetTop
            : element.offsetTop,
        });
    }, 200);
    this.selectedTab = event.index;
  }

  private offsetToAttachBottom(
    element: HTMLElement,
    scrollElement: HTMLElement
  ) {
    return (
      element.offsetTop - scrollElement.clientHeight + element.offsetHeight
    );
  }

  private canBeFullyVisible(element: HTMLElement, scrollElement: HTMLElement) {
    return element.offsetHeight < scrollElement.clientHeight;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
